import React from 'react';
import { getPositioning } from '../util';

const CalloutMessage: React.FC<any> = ({ classes, currentStep, rectMap }) => {
  if (!currentStep) return null;
  const steps = currentStep.steps ? currentStep.steps : [currentStep];

  return steps.map((x, idx) => {
    const style = getPositioning({ step: x, groupName: currentStep.groupName, rectMap });

    return (
      <div key={`step-${idx}`} className={classes.hint} style={style}>
        <img src={x?.imageUrl} alt={x?.title} className={classes.hintImage} />
      </div>
    );
  });
};
export default CalloutMessage;
